<template>
  <div class="page_content module_course" aria-label="TOC Page Content">
    <course-header ref="courseHeader" :course-id="course.uuid" :entityUuid="entity.uuid" :show-last-activity="showLastActivity" class="header_entity_learn"></course-header>
    <div class="row page-content" :class="isTocOpen ? 'toc_activated' : ''">
      <!--<t-o-c ref="toc" :uuid="course.uuid" :entity-type="entityType" :entity-uuid="entityUuid" :topic-uuid="topicUuid" :sub-topic-uuid="subTopicUuid" v-show="!showLastActivity"></t-o-c>-->
      <div v-if="allDataLoaded" class="col-12 course-description ace_sec" aria-label="entity detail section">

          <template v-if="showCourseDescription">
            <div class="header">
              <div class="heading">
                About
              </div>
            </div>
            <div class="entity-content-section col-sm-12">

              <div class="custom_container_course_about">
                <div v-html="course.description"></div>

                <div class="btn_container">
                  <b-button @click="hideCourseDescription" variant="primary" size="lg" class="btn_lg" aria-label="Continue">Continue</b-button>
                </div>
              </div>

            </div>
          </template>

          <template v-if="locked">
            <div class="row entity-nav">
              <div class="col-12 entity-title-section">
                <h3 class="row hd ace_sec_hd">
                  <span class="col-11 hd_txt"> {{entity.title}} </span>
                  <span class="col-1 ic ic_lock"></span>
                </h3>
              </div>
            </div>

            <div class="row lock_entity_msg">
              <div class="col-12 ic_lock"></div>
              <div class="col-12 msg" v-if="entity.unlockReliantOnType==4">
                This Micro Competency is locked because you have not completed the previous Competency! <br/>
                Please complete all the Micro Competency in "{{entity.unlockReliantOnTitle[0]}}" to access this.
              </div>
              <div class="col-12 msg" v-if="entity.unlockReliantOnType==5">
                This Micro Competency is locked because you have not completed the previous Micro Competency! <br/>
                Please complete  "{{entity.unlockReliantOnTitle[0]}}" Micro Competency to access this.
              </div>
              <div class="col-12 msg" v-if="entity.unlockReliantOnType==3">
                This Micro Competency is locked because you have not completed the Diagnostic Test! <br/>
                Please complete Diagnostic Test "{{entity.unlockReliantOnTitle[0]}}" to access this.
              </div>
              <div class="col-12 msg" v-if="entity.unlockReliantOnType==2">
                This Micro Competency will open on "{{entity.unlockReliantOnTitle[0]}}".
              </div>
              <div class="col-12 msg" v-if="entity.unlockReliantOnType==1">
                This Micro Competency will open when "{{entity.unlockReliantOnTitle[0]}}".
              </div>

            </div>
          </template>

          <template v-if="!showCourseDescription && !locked">
            <div class="entity-nav">
              <div class="float-left entity-title-section">
                <span v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></span>
                <span v-if="entity.fileType === 'video'" class="icon icon-video"></span>
                <span v-if="entity.fileType === 'pdf'" class="icon icon-file-pdf"></span>
                <span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="icon icon-file-word"></span>
                <span v-if="entity.fileType === 'xlsx'" class="icon icon-file-excel"></span>
                <span v-if="entity.fileType === 'scorm'" class="icon icon-scorm"></span>
                <span v-if="entity.fileType === 'html'" class="icon icon-pageURL"></span>
                <span v-if="entity.fileType === 'externalurl'" class="icon icon-pageURL"></span>
                <span v-if="entity.fileType === 'other'" class="icon icon-pageURL"></span>
                <span v-if="entity.fileType === 'zip'" class="icon icon-file-zip"></span>
                <span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="icon icon-image"></span>
                <h3 class="entity-title float-left ace_sec_hd">{{entity.title}}</h3>
              </div>
              <div>
                <b-modal id="aiContentModalContainer" class="full_screen_modal modal__v24" ref="aiContentModal"  size="" hide-footer no-close-on-backdrop no-close-on-esc :class="addPrintClass()">
                  <div slot="modal-header" class="header-section">
                    <div class="hd_ic">
                      <span class="ic ic24-ai"></span>
                    </div>
                    <div class="hd_txt">
                      {{aiResorce.title}}
                    </div>
                    <div class="btn_container">
                      <button class="btn_close" aria-label="close" @click="closeAiContentModal">
                        <span class="ic-close"></span>
                      </button>
                    </div>
                  </div>

                  <div class="row entity_head">
                    <div class="col-12">
                      <div class="ic_container">
                        <span class="ic ic24-competency"></span>
                      </div>
                      <div class="hd_txt">
                        {{ course.title }}
                      </div>
                    </div>
                  </div>

                  <div class="row sub_head">
                    <div class="col-8 hd_txt">
                      {{entity.title}}
                    </div>
                    <div class="col-4 btn_container">
                      <b-btn class="btn btn_rate" aria-label="rate this resource" @click="showRateResourceModal1" v-b-tooltip.hover title="Rate this resource">
                        <span class="ic ic24-rate"></span>
                      </b-btn>
                    </div>
                  </div>

                  <div class="rich-html-container-parent">
                    <div v-html="aiResorce.htmlBody">
                    </div>
                  </div>

                  <template v-if="ratingModalStatus">
                    <div class="pragya_pg_sub_modal rating-popup" style="height: 620px;">
                      <div id="rateModal" class="sub_modal_inner">

                        <div class="modal-header">
                          <div class="popup_head_txt head_txt text-center">
                            <span>Rate this Resource</span>
                          </div>
                          <div class="btn_container">
                            <button class="btn_close" aria-label="close" @click="hideRateResourceModal1">
                              <span class="ic-close"></span>
                            </button>
                          </div>
                        </div>

                        <div class="sub_modal_body modal-content">
                          <div>
                            <div class="row">
                              <div class="col-12 content_sec_inner pl-5">

                                <div class="content-performance">Did this resource improve your understanding of the content?</div>
                                <div class="row ratings-row_5">
                                  <div class="col-6 d-flex align-items-center pr-0">
                                    <fieldset>
                                      <input class="mr-2" type="radio" name="ranking" id="five" value="5" v-model="rating" @change="enableStarAndOkButton">
                                      <label class="m-0" for="five">Extremely Helpful</label>
                                    </fieldset>
                                  </div>
                                  <div class="col-6 pl-0">
                                    <label for="five">
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                    </label>
                                  </div>
                                </div>
                                <br>
                                <div class="row ratings-row_4">
                                  <div class="col-6 d-flex align-items-center pr-0">
                                    <input class="mr-2" type="radio" name="ranking" id="four" value="4" v-model="rating" @change="enableStarAndOkButton">
                                    <label class="m-0" for="four">Very Helpful</label>
                                  </div>
                                  <div class="col-6 pl-0">
                                    <label for="four">
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                    </label>
                                  </div>
                                </div>
                                <br>
                                <div class="row ratings-row_3">
                                  <div class="col-6 d-flex align-items-center pr-0">
                                    <input class="mr-2" type="radio" name="ranking" id="three" value="3" v-model="rating" @change="enableStarAndOkButton">
                                    <label class="m-0" for="three">Moderately Helpful</label>
                                  </div>
                                  <div class="col-6 pl-0">
                                    <label for="three">
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                    </label>
                                  </div>
                                </div>
                                <br>
                                <div class="row ratings-row_2">
                                  <div class="col-6 d-flex align-items-center pr-0">
                                    <input class="mr-2" type="radio" name="ranking" id="two" value="2" v-model="rating" @change="enableStarAndOkButton">
                                    <label class="m-0" for="two">Slightly Helpful</label>
                                  </div>
                                  <div class="col-6 pl-0">
                                    <label for="two">
                                      <span class="icon-star-full"></span>
                                      <span class="icon-star-full"></span>
                                    </label>
                                  </div>
                                </div>
                                <br>
                                <div class="row ratings-row_1">
                                  <div class="col-6 d-flex align-items-center pr-0">
                                    <input type="radio" class="mr-2" name="ranking" value="1" id="one" v-model="rating" @change="enableStarAndOkButton">
                                    <label class="m-0" for="one">Not Helpful</label>
                                  </div>
                                  <div class="col-6 pl-0">
                                    <label for="one">
                                      <span class="icon-star-full"></span>
                                    </label>
                                  </div>
                                </div>
                                <br>
                                <div class="row ratings-row_0">
                                  <div class="col-6 d-flex align-items-center pr-0">
                                    <input type="radio" class="mr-2" name="ranking" value="0" id="zero" v-model="rating" @change="enableStarAndOkButton">
                                    <label class="m-0" for="zero">N/A (Not Accessible)</label>
                                  </div>
                                  <div class="col-6 pl-0">
                                  </div>
                                </div>
                                <div class="feedback-form">
                                  <div class="note-text">If you have any comments please type it in (optional)</div>
                                  <textarea rows="5" cols="50" id="feedback" maxlength="1022" aria-label="share your feedback"
                                    v-model.trim="feedback">
                                  </textarea>
                                </div>

                              </div>
                            </div>

                            <div class="submit-btn pt-4" style="padding-right: 8px;">
                              <b-button v-on:click="sendRating" class="btn button-primary next float-right" disabled id="ok-btn" aria-label="ok"> ok </b-button>
                            </div>

                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="pragya_pg_bg_layer" @click="hideRateResourceModal1"></div>
                  </template>
                </b-modal>
              </div>

              <div class="btn_container entity_dtl_hd_btns">
                <template v-if="this.aiResorce.uuid">
                  <b-btn class="btn btn_ic_ai" @click="openAiContentModal" style="margin: 0px 10px 0px 7px;" aria-label="Show Pragya AI Content" v-b-tooltip.hover title="Show Pragya AI Content">
                    <span class="ic ic24-ai"></span>
                    <span id="pragyaGuideDisplayBtn" v-if="pragyaGuideBtn" style="display: block;">.</span>
                  </b-btn>

                  <template v-if="isTourEnabled">
                    <template v-if="!isDoNotOpenGuide">
                      <b-popover ref="pragyaAiButtonModal" :show.sync="pragyaGuideModal__Ai" target="pragyaGuideDisplayBtn" triggers="click" show="true" placement="bottom" container="pragyaAIButtonPopoverContainer" class="popover_v4">
                          <div class="row">
                            <div class="col-12 mb-3">
                              <template v-if="entity.objectType === 'LearningTopic'">
                                Pragya AI can give you a summary of this topic and why it is important. Would you like to see it?
                              </template>
                              <template v-if="entity.objectType === 'LearningContent'">
                                Pragya AI can explain the questions in the knowledge check and give you some hints. Would you like to see it?
                              </template>
                            </div>
                          </div>

                          <div class="row btn_container">
                            <div class="col-6 left">
                              <b-btn class="btn btn_clr_2" @click="closePragyaGuideModal">
                                not now
                              </b-btn>
                            </div>
                            <div class="col-6 right">
                              <b-btn class="btn" @click="openAiContentModal">
                                show me
                              </b-btn>
                            </div>
                          </div>

                          <div class="row actions mt-3">
                            <div class="col-12 hide_tour_check">
                              <input type="checkbox" v-model="isDoNotOpenGuide" id="hideApplicationTour">
                              <label for="hideApplicationTour">Don't show me this again</label>
                            </div>
                          </div>
                        </b-popover>
                      </template>
                    </template>
                </template>

                <template v-if="entity.objectType === 'LearningContent' || course.includeCDesc || course.includeCAI">
                  <b-button v-if="prevTOCuuid" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: prevTOCType, entityUuid: prevTOCuuid, action: 'clickCourseTraversePrev', locked:toBeLockedPr } }" class="btn" aria-label="previous">
                    <span class="btn_txt" v-on:click="scrollUpToC">prev</span>
                  </b-button>
                  <b-button v-else class="btn" disabled>
                    <span class="btn_txt" v-on:click="scrollUpToC">prev</span>
                  </b-button>
                  <b-button v-if="nextTOCuuid" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: nextTOCType, entityUuid: nextTOCuuid, action: 'clickCourseTraverseNext' , locked:toBeLocked} }" class="btn" aria-label="next">
                    <span class="btn_txt" v-on:click="scrollToC">next</span>
                  </b-button>
                  <b-button v-else class="btn" disabled>
                    <span class="btn_txt" v-on:click="scrollToC">next</span>
                  </b-button>
                </template>
              </div>
            </div>

            <div id="pragyaAIButtonPopoverContainer" class="popover_container_v4 no_header pragya_guide_container"></div>

            <div class="entity-content-section col-sm-12">
              <div v-if="entity.type !== 'ASSESSMENT'">
                <template v-if="entity.fileType === 'zip'">
                  <p class="ace_sec_txt" style="line-height: 20pt;">
                    The {{entity.title}} consist of a single .ZIP file. You will need to download the <b>{{entity.fileName}}</b> file to your PC or Mac (the file is not compatible with a mobile device) and unzip the file. Once unzipped, all of the files will reside in one folder.
                  </p>
                </template>
                <template v-if="entity.objectType === 'LearningTopic'">
                  <div class="entity_desc_v2" v-html="entity.description" v-if="entity.description"></div>
                  <template v-if="entity.ancestor === course.uuid">
                    <div class="inst_msg" v-html="institution.messageAfterCompetencyDescription" v-if="institution.messageAfterCompetencyDescription"></div>
                  </template>
                   <template v-else>
                    <div class="inst_msg" v-html="institution.messageAfterMicroCompetencyDescription" v-if="institution.messageAfterMicroCompetencyDescription"></div>
                  </template>
                  <div class="rich-html-container-parent ai_desc_sec" v-if="course.includeCAI">
                    <div class="row pg_hd" v-if="aiResorce.htmlBody">
                      <div class="col-1 hd_ic ic24-ai"></div>
                      <div class="col-11 hd_txt">
                        Pragya AI Summary
                      </div>
                    </div>
                    <div v-html="aiResorce.htmlBody"></div>
                  </div>

                </template>
              </div>
              <template v-if="isEntityActivityLoaded">
                <!-- REMOVE SHOWING TIME TAKEN
                <br>
                <template v-if="((entity.type === 'ASSESSMENT') || (entity.type === 'RESOURCE'))">
                  <div v-if="entity.type === 'ASSESSMENT'" class="resource_time_taken ace_sec_txt">
                    Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.assessmentTimeTaken)}}</strong>
                  </div>
                  <div  v-else class="resource_time_taken ace_sec_txt">
                    Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.resourceTimeTaken)}}</strong>
                  </div>
                </template>
                <template v-else>
                  <div class="resource_time_taken ace_sec_txt">
                    Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.assessmentTimeTaken + entityActivity.resourceTimeTaken)}}</strong>
                  </div>
                </template>
                -->
              </template>
              <div v-if="entity.objectType === 'LearningContent'" class="learning entity-detail ace_sec_txt pg_sec_bx">
                <div class="pg_sec_bx_inner">
                  <div class="entity_desc">
                    <template v-if="((course.courseType === 'RICH_HTML_SUPPORT') && (entity.type === 'RICH_HTML'))">
                      <template v-if="isEntityDetailLoaded">
                        <rich-html-launch-assessment :resource-id="entityUuid" :html="entity.htmlBody" :course-id="course.uuid" @afterRender="afterRenderRichHtml" :container-class="'rich-html-container'"></rich-html-launch-assessment>
                      </template>
                    </template>
                    <template v-else>
                      <div v-if="entity.type === 'ASSESSMENT'">
                        <template v-if="isEntityDetailLoaded">
                          <assessment-detail :uuid ="entity.uuid" :course-id="course.uuid"></assessment-detail>
                        </template>
                      </div>
                      <div v-else>
                        <span v-html="entity.description"></span>
                        <template v-if="entityActivity && entityActivity.status === 1">
                          You can continue learning this resource any time by clicking on it in the Table of Contents or by clicking "Resume".
                          <b-button :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: entity.uuid } }" variant="primary" size="lg" class="btn_lg" aria-label="Resume">Resume</b-button>
                        </template>
                        <template v-if="entityActivity && entityActivity.status === 2">
                          Great! You’re done with this learning resource.
                          <b-button :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: entity.uuid } }" variant="primary" size="lg" class="btn_lg" aria-label="Learn Again">Learn Again</b-button>
                        </template>
                        <template v-if="!entityActivity || (entityActivity && entityActivity.status === 0)">
                          You can start learning this resource by clicking on "Start".
                          <b-button :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: entity.uuid } }" variant="primary" size="lg" class="btn_lg" aria-label="Start">Start</b-button>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div v-else>
                <!--
                <p>Progress</p>
                <hr>
                <b-card class="course-description-card"></b-card>

                <p>Competencies</p>
                <hr>
                <b-card class="course-description-card"></b-card>
                -->
              </div>
            </div>
          </template>
      </div>

      <stretch class="loader_v23" v-if="!allDataLoaded"></stretch>

      <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF">
            <div><i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i></div>
            <div class="mt-4" v-if="isRecalutingClassAverage">
              <span>Recalculating Class Average</span>
            </div>
          </div>
        </b-modal>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import TOC from './TOC'
import AssessmentDetail from '../../assessment/components/AssessmentDetail'
import RichHtmlLaunchAssessment from '../../assessment/components/RichHtmlLaunchAssessment'
import { PACKAGE } from '../../../package_constants'
import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'course-learn',
  props: ['uuid', 'entityType', 'entityUuid', 'topicUuid', 'subTopicUuid', 'action', 'showLastActivity', 'forceShowTour', 'locked'],
  components: {
    CourseHeader,
    CourseNav,
    TOC,
    AssessmentDetail,
    RichHtmlLaunchAssessment,
    feedback: null,
    isDoNotOpenGuide: false,
    Stretch
  },
  data: () => {
    return {
      isEntityDetailLoaded: false,
      isEntityActivityLoaded: false,
      nextTOCuuid: null,
      nextTOCType: null,
      prevTOCuuid: null,
      prevTOCType: null,
      toBeLocked: false,
      toBeLockedPr: false,
      entityActivity: null,
      allDataLoaded: false,
      showCourseDescription: false,
      showFirst:true,
      aiResorce : {},
      aiContentMap : {},
      rating: -1,
      ratingModalStatus: false,
      pragyaGuideBtn: true,
      pragyaGuideModal__Ai: false
    }
  },

  updated () {
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.showLastActivity) {
          // this.$refs.courseHeader.hideToc()
        }
      })
    })
  },

  mounted () {
    if (!this.isStudentLogin) {
      return this.$router.push({ name: 'entityDetailInstructor', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid, topicUuid: this.topicUuid, subTopicUuid: this.subTopicUuid } })
    }
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadUserPreferences',
      'loadSaveProfileTour',
      'loadCourseDetail',
      'loadCourseTopics',
      'loadEntityDetail',
      'loadEntityActivity',
      'loadAIResource',
      'stopActivity',
      'storeRating',
      'loadLogDashboardActivity',
      'loadForceResetTourElements',
      'loadAIContents'
    ]),

    async loadCourse () {
      this.allDataLoaded = false
      if (this.action) {
        let page = (this.action.indexOf('CourseTraverse') !== -1) ? 'courseLearn' : 'courseHome'
        this.loadLogDashboardActivity({action: this.action, page: page, link: '', entityUuid: this.uuid})
      }
      this.isEntityActivityLoaded = false
      await this.loadCourseDetail(this.uuid)
      var entityActityInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.aiContentMap = await this.loadAIContents(this.uuid)
      this.aiResorce = {uuid:this.aiContentMap[this.entityUuid]}
      if(this.aiResorce.uuid && this.course.includeCAI ) {
        var entityDetailInfo = {
          'entityUuid': this.aiResorce.uuid,
          'entityType': 'LearningContent'
        }
        this.aiResorce  = await this.loadAIResource(entityDetailInfo)
      }

      let res = await this.loadEntityActivity(entityActityInfo)
      if (res) {
        this.entityActivity = res
        if (this.entityActivity.status === 2 || this.entityActivity.status === 3) {
          this.isEntityActivityLoaded = true
        }
      }

      await this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true})
      var i = 0
      var j = 0
      var k = 0
      this.toBeLocked = false
      for (i = 0; i < this.linearTopics.length; i++) {
        if (this.linearTopics[i].uuid === this.entityUuid) {
          for (j = i + 1; j < this.linearTopics.length; j++) {
            if(this.linearTopics[j].locked){
                this.nextTOCuuid = this.linearTopics[j].uuid
                this.nextTOCType = this.linearTopics[j].objectType
                this.toBeLocked = true
                break
            }
            if(this.course.includeCAI || this.course.includeCDesc){
                this.nextTOCuuid = this.linearTopics[j].uuid
                this.nextTOCType = this.linearTopics[j].objectType
                break
            }else{
              if (this.linearTopics[j].objectType !== 'LearningTopic') {
                this.nextTOCuuid = this.linearTopics[j].uuid
                this.nextTOCType = this.linearTopics[j].objectType
                break
              }
            }
          }
          this.toBeLockedPr = false
          for (k = i - 1; k >= -1; k--) {
            if (k === -1) {
              k = this.linearTopics.length - 1
            }
            if(this.course.includeCAI || this.course.includeCDesc){
                this.prevTOCuuid = this.linearTopics[k].uuid
                this.prevTOCType = this.linearTopics[k].objectType
                if (this.linearTopics[k].objectType !== 'LearningTopic') {
                  //check if parent is locked
                    for(let r=1;(k-r)>0; r++){
                      if(this.linearTopics[k-r].objectType ==='LearningTopic'){
                          if(this.linearTopics[k-r].locked){
                              this.toBeLockedPr = true
                              this.prevTOCuuid = this.linearTopics[k-r].uuid
                              this.prevTOCType = this.linearTopics[k-r].objectType
                          }
                          break;
                      }
                    }
                  }
                break
            }else{
              if (this.linearTopics[k].objectType !== 'LearningTopic') {
                this.prevTOCuuid = this.linearTopics[k].uuid
                this.prevTOCType = this.linearTopics[k].objectType
                  //check if parent is locked
                  for(let r=1;(k-r)>0; r++){
                    if(this.linearTopics[k-r].objectType ==='LearningTopic'){
                        if(this.linearTopics[k-r].locked){
                            this.toBeLockedPr = true
                            this.prevTOCuuid = this.linearTopics[k-r].uuid
                            this.prevTOCType = this.linearTopics[k-r].objectType
                        }
                        break;
                    }
                  }

                break
              }
            }
          }
          break
        }
      }
      if (j < k || (k==0 && (this.course.includeCAI || this.course.includeCDesc))) {
        this.prevTOCuuid = null
        if (!this.entityActivity) {
          this.showCourseDescription = true
        }
      }
      if (j === this.linearTopics.length) {
        this.nextTOCuuid = null
      }
      if(i>0 && i<3 && (this.course.includeCAI || this.course.includeCDesc)){// 1 means first KC/R of C 2 means from MC
          this.prevTOCuuid = this.linearTopics[i-1].uuid
          this.prevTOCType = this.linearTopics[i-1].objectType
      }

      var entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      let resEntity = await this.loadEntityDetail(entityDetailInfo)
      if (resEntity && ((resEntity.type === 'ASSESSMENT') || (resEntity.type === 'RICH_HTML'))) {
        this.isEntityDetailLoaded = true
      }
      // Navigate to learn if its a not an assessment or rich html
      if (resEntity && resEntity.type !== 'ASSESSMENT' && resEntity.type !== 'SCORM' && !this.showCourseDescription) {
        return this.$router.push({ name: 'entityLearn', params: { uuid: this.course.uuid, entityType: this.entity.objectType, entityUuid: this.entity.uuid } })
      }
      this.allDataLoaded = true

      this.loadUserPreferences().then(res => {
        this.isDoNotOpenGuide = res.doNotOpenGuide
      })
    },
    hideCourseDescription () {
      this.showCourseDescription = false
      if(this.course.includeCAI || this.course.includeCDesc){
            this.entity.title = ''
            this.entity.fileType = ''
            return this.$router.push({ name: 'entityDetail', params: { uuid: this.course.uuid, entityType: this.linearTopics[0].objectType, entityUuid: this.linearTopics[0].uuid } })
      }
      if (this.entity && this.entity.type !== 'ASSESSMENT' && this.entity.type !== 'SCORM' ) {
        return this.$router.push({ name: 'entityLearn', params: { uuid: this.course.uuid, entityType: this.entity.objectType, entityUuid: this.entity.uuid } })
      }
    },
    openAiContentModal () {
    this.showLoader()
    if(this.$refs.aiContentModal){
      var entityDetailInfo = {
        'entityUuid': this.aiResorce.uuid,
        'entityType': 'LearningContent'
      }
      this.loadAIResource(entityDetailInfo).then(res => {
        this.aiResorce = res
        this.$refs.aiContentModal.show()
        this.hideLoader()
      })
     }
     this.closePragyaGuideModal()
    },
    closeAiContentModal () {
      this.$refs.aiContentModal.hide()
    },
    showPragyaGuideModal () {
      this.pragyaGuideBtn = true
      this.pragyaGuideModal__Ai = true
      $('#pragyaGuideDisplayBtn').show()
    },
    closePragyaGuideModal () {
      this.pragyaGuideBtn = false
      this.pragyaGuideModal__Ai = false
      $('#pragyaGuideDisplayBtn').hide()
      this.saveProfile()
    },
    saveProfile () {
      this.loadSaveProfileTour({isDoNotOpenGuide: this.isDoNotOpenGuide})
    },
    showRateResourceModal1 () {
      this.ratingModalStatus = true
    },
    hideRateResourceModal1 () {
      this.ratingModalStatus = false
    },
    enableStarAndOkButton () {
      if ($('#four').is(':checked')) {
        $('.ratings-row_4').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_3, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#three').is(':checked')) {
        $('.ratings-row_3').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_4, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#two').is(':checked')) {
        $('.ratings-row_2').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_4, .ratings-row_3, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#one').is(':checked')) {
        $('.ratings-row_1').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_4, .ratings-row_3, .ratings-row_2 ').removeClass('selected-star')
      } else if ($('#five').is(':checked')) {
        $('.ratings-row_5').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_3, .ratings-row_4, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#zero').is(':checked')) {
        $('.ratings-row_0').addClass('selected-star')
        $('.ratings-row_3,.ratings-row_5, .ratings-row_4, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      }
      $('#ok-btn').prop('disabled', false)
      $('#ok-btn').removeClass('disabled')
    },
    sendRating () {
      if (this.ratingFeatureEnabled) {
        let feedback = $.trim(this.feedback)
        let entityUuid = this.uuid + '&resourceUuid=' + this.aiResorce.uuid + '&rating=' + this.rating + '&ratingComment=' + ((feedback.length > 0) ? feedback : undefined)
        this.loadLogDashboardActivity({action: 'clickRateResource', page: 'courseLearn', link: '', entityUuid: entityUuid})
        var ratingInfo = {
          'courseId': this.uuid,
          'learningContentId': this.aiResorce.uuid,
          'userId': localStorage.getItem('userid'),
          'institutionId': null,
          'rating': this.rating,
          'ratingLabel': null,
          'feedback': ((feedback.length > 0) ? feedback : null)
        }
        this.storeRating(ratingInfo)
      }
      this.ratingModalStatus = false
    },
    leaving () {
      var stopActivity = {
        'userId': localStorage.getItem('userid'),
        'entityUuid': this.entityUuid,
        'rating': this.rating
      }
      this.stopActivity(stopActivity).then((res) => {
        this.sendRating()
        this.ratingModalStatus = false
        //return this.$router.push({ name: 'entityResult', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid } })
      })
    },
    msToTime (s) {
      if (s === undefined) {
        return '0 hrs 0 mins 0 seconds'
      }
      var ms = s % 1000
      s = (s - ms) / 1000
      var secs = s % 60
      s = (s - secs) / 60
      var mins = s % 60
      var hrs = (s - mins) / 60
      return hrs + ' hrs ' + mins + ' mins ' + secs + ' seconds'
    },
    scrollUpToC () {
      /*
      var $container = $('.content-scroll-column')
      var $scrollTo = $('.active_row')
      $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop() - 180, scrollLeft: 0}, 300)
      */
    },
    scrollToC () {
      /*
      var $container = $('.content-scroll-column')
      var $scrollTo = $('.active_row')
      $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(), scrollLeft: 0}, 300)
      */
    },
    afterRenderRichHtml () {
      this.$refs.courseHeader.hideToc()
    },
    showLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.show()
      }
    },
    hideLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    },
    isPrintDisable () {
      if (this.enabledFeatures && this.enabledFeatures['disablePrint']) {
        return this.enabledFeatures['disablePrint'].enabled
      }
      return false
    },
    addPrintClass () {
      if (this.isPrintDisable()) {
        return 'no_print_win'
      } else {
        return ''
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'topics': state => state.course.topics,
      'entity': state => state.course.entity,
      'institution': state => state.institution.institution,
      'isTocOpen': state => state.course.isTocOpen,
      'linearTopics': state => state.course.linearTopics,
      'enabledFeatures': state => state.institution.enabledFeatures,
    }),
    isStudentLogin: function () {
      return (localStorage.getItem('userrole') === 'Student')
    },
    ratingFeatureEnabled () {
      let ratingFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_RESOURCE_RATING]
      if (!ratingFeature || !ratingFeature.enabled) {
        return false
      }
      return ratingFeature.enabled
    },
    isTourEnabled () {
      let tourFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TOUR_FEATURE_ID]
      if (tourFeature) {
        return tourFeature.enabled
      }
      return false
    }
  },

  watch: {
    entityUuid (newId) {
      if (newId) {
        if(this.aiContentMap[newId]){
          this.aiResorce = {uuid:this.aiContentMap[newId]}
        }else{
          this.aiResorce = {}
        }
        // this.$refs.toc.$refs.loadingModal.show()
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>
.content{
  padding-top: 40px;
  margin-right: 30px;
  margin-left: 30px;
}

.course-nav{
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item{
  background:#e1e1e1;
  border: none;
}

.course-thumbnail{
  background:#f8f9fa;
  min-height: 500px;
}

.course-information{
  margin-top:20px;
}

.course-description{
  padding-top:0px;
  padding-left:0px;
  padding-right:0px;
}

.course-description-card{
  background:#f8f9fa;
  border-color: #f8f9fa;
}

.topic-list-item{
}
.pull-left{
  float:left;
}

.learning{
  margin-top: 30px;
}

.next, .previous {
	font-weight: bold!important;
    font-size: 18px;
    padding: 0px 11px 0px 11px!important;
	margin-right:4px;
}
.entity-title-section {
	width: calc(100% - 224px);
	display: flex;
    align-items: center;
    height: 63px;
}
img {
	width:28px;
	height:26px;
}

.roboto-text {
	font-size:17px;
}
.btn_rate .ic24-rate {
  font-size: 26px !important;
}

</style>



// WEBPACK FOOTER //
// src/app/course/components/EntityDetail.vue